<template>
  <v-card>
    <v-toolbar flat color="white" density="compact">
      <v-tabs v-model="tab" slider-color="success" grow>
        <v-tab color="primary">{{ $store.getters.translate("general_info").toUpperCase() }}</v-tab>
        <v-tab v-if="show_2nd_tab" color="primary">{{ $store.getters.translate("additional_information").toUpperCase() }}</v-tab>
      </v-tabs>
      <v-spacer/>
      <div class="chip-container">
        <base-action-button v-if="page.name === 'companies'" @action="$emit('export','pdf')">
          <template #prepend><PhFilePdf style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("export_to_pdf") }}
        </base-action-button>
        <base-action-button v-if="page.name === 'companies'" @action="$emit('export','excel')">
          <template #prepend><PhFileXls style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("export_to_excel") }}
        </base-action-button>
        <base-action-button v-if="canDelete" :delete="true" @action="archive">
          <template #prepend><PhArchive style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("delete") }}
        </base-action-button>
        <base-action-button v-if="canEdit" @action="save">
          <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("save") }}
        </base-action-button>
      </div>
    </v-toolbar>
    <v-window v-model="tab">
      <v-window-item>
        <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
          <template v-for="field in usual_fields">
            <v-autocomplete
                v-if="field.name === 'metabase_dashboard'"
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                :isDisabled="!canEdit"
                v-model="record.metabase_dashboard"
                :items="metabase_dashboards"
                :return-object="false"
                item-value="value"
                item-title="text"
                hide-details
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('metabase_dashboard') }}</span>
              </template>
            </v-autocomplete>
            <base-field
                v-else
                :isDisabled="!canEdit"
                :key="field.name"
                :modelValue="record[field.name]"
                :field="field"
                @change="usualFieldDataChanged"/>
          </template>
          <base-tags v-if="tags_required" :modelValue="record.tags" :modal_name="page.name" :label="$store.getters.translate('tags')" @change="tagsChanged"/>
        </v-card>
      </v-window-item>
      <v-window-item v-if="show_2nd_tab">
        <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
          <slot name="additional_information"/>
        </v-card>
      </v-window-item>
    </v-window>
  </v-card>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import {PhArchive, PhFloppyDisk, PhFilePdf, PhFileXls} from "@phosphor-icons/vue";
import BaseTags from "./BaseTags";

export default {
  components: {BaseTags, BaseActionButton, PhFloppyDisk, PhArchive, PhFilePdf, PhFileXls },
  props: ["page", "record", "show_2nd_tab"],
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      tab: 0,
      usual_fields: [],
      tags_required: false,
      metabase_dashboards: [],
    };
  },
  mounted() {
    this.getFields();
    if(this.page.name === 'roles') {
      this.getMetabaseDashboards();
    }
  },
  methods: {
    async save() {
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, this.usual_fields)) {
        if (await helpFunctions.saveModel(this.$toast, this.page.name, this.record)) {
          this.$emit('reload');
        }
      }
    },
    async archive() {
      this.$confirm(this.$store.getters.translate("confirm")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, this.record.id);
          await this.$router.push("/" + this.page.name);
        }
      });
    },
    async getMetabaseDashboards() {
      this.metabase_dashboards = [];
      let response = await helpFunctions.getCustomRoute(this.$toast, "metabase-dashboards", false);
      for (let i = 0; i < response.length; i++) {
        this.metabase_dashboards.push({
          value: response[i].id,
          text: response[i].name,
        });
      }
    },
    usualFieldDataChanged(data) {
      if(this.record[data[0]] !== data[1]) {
        this.record[data[0]] = data[1];
      }
    },
    tagsChanged(data) {
      this.record.tags = data;
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, "show_on_update");
      this.tags_required = response.tags_required;
      this.usual_fields = response.usual_fields;
    },
  },
  computed: {
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
  },
};
</script>

<style scoped>
.chip-container {
  display: flex;
  gap: 8px;
  margin-right: 16px;
}
</style>